import { formatDate } from '@avantstay/backoffice-core'

interface DateInterface {
  date: () => Date
}

interface ParsedResult {
  start: DateInterface
  end?: DateInterface
}

const mountReturnObj = (startDate?: Date | string, endDate?: Date | string) => {
  if (!startDate) {
    return undefined
  }

  return { startDate: formatDate(startDate), endDate: formatDate(endDate) }
}

export const getChronoDates = (result?: ParsedResult) => {
  if (!result) {
    return mountReturnObj()
  }

  if (result.end) {
    return mountReturnObj(result.start.date(), result.end!.date())
  }

  return mountReturnObj(result.start.date(), result.start.date())
}
